// Create a function with the code for the listener. The code is the same as before.
const initPagefind = () => {
  const queryString = window.location.search,
        urlParams    = new URLSearchParams(queryString),
        searchString = urlParams.get("q");

  const pagefind = new PagefindUI({
    element: "#search",
    pageSize: 10,
    showSubResults: false,
    showEmptyFilters: false,
    resetStyles: true,
    excerptLength: 8,
    debounceTimeoutMs: 300,
    bundlePath: "/pagefind/"
  });

  const searchButton     = document.querySelector("#searchButton"),
        searchWrapper    = document.querySelector("#searchWrapper"),
        searchInput      = document.querySelector(".pagefind-ui__search-input"),
        searchModalClose = document.querySelector("#searchModalClose");

  const openSearchUi = () => {
    searchButton?.classList.toggle("border-current");
    searchWrapper?.classList.toggle("hidden");
    document.body.classList.toggle("overflow-y-hidden");
    searchInput?.focus();
  };

  const closeSearchUi = () => {
    searchButton?.classList.remove("border-current");
    searchWrapper?.classList.add("hidden");
    document.body.classList.remove("overflow-y-hidden");
  };

  if (searchButton && searchWrapper) {
    const searchArea = document.querySelector("#search");

    document.addEventListener("click", (event) => {
      if (!searchWrapper.classList.contains("hidden") &&
          !searchArea.contains(event.target) &&
          !searchButton.contains(event.target)) {
        closeSearchUi();
      }
    });

    searchArea.addEventListener("click",       (e) => e.stopPropagation());
    searchArea.addEventListener("mousedown",   (e) => e.stopPropagation());
    searchArea.addEventListener("touchstart",  (e) => e.stopPropagation());

    const closeOnBackground = (event) => {
      if (event.target === searchWrapper) closeSearchUi();
    };
    searchWrapper.addEventListener("mousedown",  closeOnBackground);
    searchWrapper.addEventListener("touchstart", closeOnBackground);

    if (searchString) {
      pagefind.triggerSearch(searchString);
      openSearchUi();
    }

    searchButton.addEventListener("click",   openSearchUi);
    searchModalClose.addEventListener("click", () => closeSearchUi());
    window.addEventListener("keydown", (event) => {
      if (event.key === "Escape") closeSearchUi();
    });
  } else {
    if (searchString) pagefind.triggerSearch(searchString);
  }
};

// Works with or without cookie block. 
// Uses the state of the dom to create the listener if it is loading 
// and if it has already loaded in the case of the cookie consent block, 
// executes only the function to initiate the pagefind ui properly.

if (document.readyState === "loading") {
  window.addEventListener("DOMContentLoaded", initPagefind, { once: true });
} else {
  initPagefind();
}
